module.exports = __webpack_public_path__ + "img/setting_4.76fcad72.svg";